export default "__VITE_ASSET__5bad7eb6__"